import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { type FC } from "react";
import { COLOR_GREY_8 } from "shared/theme/colors";
import { StyledRectangleContainer, StyledContainer } from "./styled";

const FourVerticalCardBlockPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <Rectangle title="1" />
      <Rectangle title="2" />
      <Rectangle title="3" />
      <Rectangle title="4" />
    </StyledContainer>
  );
};

type Props = {
  title: string;
};

const Rectangle: FC<Props> = ({ title }) => {
  return (
    <Box display="flex" alignItems="center">
      <Typography color={COLOR_GREY_8} fontWeight={900} fontSize="14px">
        {title}
      </Typography>
      <StyledRectangleContainer />
    </Box>
  );
};

export default FourVerticalCardBlockPlaceholder;
